import { cn } from '../../lib/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { PeriodContext } from '../../context/PeriodProvider';
import { useContext } from 'react';

export const SelectPeriod = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    const { period, isCurrentQuarter, increaseQuarter, decreaseQuarter } = useContext(PeriodContext);

    return (
        <div className={cn('flex items-center gap-1 md:gap-3', className)} {...props}>
            <button className="px-2 text-lg text-primary" onClick={decreaseQuarter} title="Vorig kwartaal">
                <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <div className="text-lg font-bold text-primary">{`Q${period.quarter} - ${period.year}`}</div>

            <button
                className={`p-2 text-lg text-primary disabled:opacity-50`}
                disabled={isCurrentQuarter}
                onClick={increaseQuarter}
                title="Volgend kwartaal"
            >
                <FontAwesomeIcon icon={faArrowRight} />
            </button>
        </div>
    );
};
